var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCirculos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isotipo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1054.771,
    height: 979.367,
    viewBox: "0 0 1054.771 979.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15742",
    "data-name": "Trazado 15742",
    d: "M208.379,30.319c12.53,8.559,12.384,8.181,24.108,17.085C368.305,150.672,442.594,283.308,428.116,467.3a494.444,494.444,0,0,1-44.144,162.1C328.016,752.389,223.693,836.163,79.933,886.5a6.385,6.385,0,0,0-4.208,5.887,7.605,7.605,0,0,0,6.355,8.467,66.847,66.847,0,0,0,20.835-3.734C213.6,858.787,302.042,791.015,362.81,690.581c92.6-153.081,101.356-321.269,30.025-465.4C364.143,167.21,319.786,116.857,266.094,69.05a386.811,386.811,0,0,0-69.76-47.427C189.258,17.7,182.47,13.8,175.5,10.2c-6.251-3.219-9.975-5.543-19-9.623a9.929,9.929,0,0,0,1.34.782c7.826,4.037,9.845,5.256,17.6,9.5C181.552,14.189,202.656,26.4,208.379,30.319Z",
    transform: "translate(564.219 -0.575)",
    fill: "#06132f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15743",
    "data-name": "Trazado 15743",
    d: "M25.694,470.6c13.085,17.472,48.522,33.107,81.5,47.845,87.063,38.908,216.6,63.711,319.382,40.292C695.857,508.62,866.237,272.717,870.878,55.2,844.083,253.925,748.753,407.279,567.9,496.581,387.715,585.539,208.955,570.263,31.183,465.7a2.843,2.843,0,0,0-.795-.47,3.832,3.832,0,0,0-4.694,5.365Z",
    transform: "translate(183.893 411.535)",
    fill: "#06132f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15744",
    "data-name": "Trazado 15744",
    d: "M439.294,587.6c.094-.212.239-.55.333-.787,50.725-130.867,51.127-253.589-20.88-376.871C340.75,76.4,217.988,10.879,63.665,1.545,207.163,19.788,326.1,81.029,401.458,206.288c73.57,122.236,71.374,247.1,21.051,382.411a4.423,4.423,0,0,0,1.214,4.5,8.862,8.862,0,0,0,6.94,1.43,16.583,16.583,0,0,0,7.957-6.011A5.554,5.554,0,0,0,439.294,587.6Z",
    transform: "translate(473.669 6.737)",
    fill: "#06132f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15745",
    "data-name": "Trazado 15745",
    d: "M239.125,775.745C86.6,684.825,3.738,553.333,19.41,374.02,35,195.74,138.7,82.2,304.951,23.977a5.309,5.309,0,0,0,3.5-4.895,6.327,6.327,0,0,0-5.294-7.049,55.633,55.633,0,0,0-17.329,3.113,396.105,396.105,0,0,0-216.335,171.9C-38.576,365.72-7.183,576.839,148.61,715.563,175.409,739.417,208.791,755.859,239.125,775.745Z",
    transform: "translate(36.835 85.867)",
    fill: "#06132f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15746",
    "data-name": "Trazado 15746",
    d: "M704.293,85.265C693.386,70.717,663.9,57.7,636.435,45.433,563.968,13.044,456.156-7.589,370.6,11.9,146.467,53.614,4.653,249.965.8,431.014,23.088,265.6,102.443,137.961,252.975,63.645,402.952-10.414,551.734,2.3,699.73,89.337a2.369,2.369,0,0,0,.661.392,3.189,3.189,0,0,0,3.9-4.464Z",
    transform: "translate(-0.795 27.74)",
    fill: "#06132f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15747",
    "data-name": "Trazado 15747",
    d: "M39.524,47.161l-.267.63c-42.182,108.95-38,216.364,21.9,318.962C126.067,477.883,225.015,536.1,353.444,543.863,234.021,528.694,138.261,474.041,75.55,369.786c-61.231-101.767-63.909-210.922-22-323.555a3.7,3.7,0,0,0-1.019-3.748,7.38,7.38,0,0,0-5.776-1.188,13.76,13.76,0,0,0-6.613,4.985A4.949,4.949,0,0,0,39.524,47.161Z",
    transform: "translate(78.466 305.402)",
    fill: "#06132f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCirculos);
export default __webpack_public_path__ + "static/media/dashboard-circulos.3ff5107527e8c34276f264cc0ead480c.svg";
export { ForwardRef as ReactComponent };